import { useTranslation } from "react-i18next";
import React, { useRef, useEffect } from 'react';
import { FormGroup, FormFeedback, Input, Label } from 'reactstrap';
export default function FAQInputGroup({
  title,
  content,
  order,
  setTitle,
  setContent,
  setOrder,
  error,
  focus
}) {
  const {
    t
  } = useTranslation();
  const inputEl = useRef(null);
  useEffect(() => {
    if (focus && inputEl.current) {
      inputEl.current.focus();
    }
  }, [focus]);
  return <FormGroup>
      <Label for='order' className="faqLabel">{t("Order Position:")}</Label>
      <Input type='number' name='order' placeholder={t("Enter the faq order position")} value={order} onChange={e => setOrder(e.target.value)} invalid={!!error} innerRef={inputEl} />
      <Label for='title' className="faqLabel">{t("Question:")}</Label>
      <Input type='string' name='title' placeholder={t("Enter the faq title")} value={title} onChange={e => setTitle(e.target.value)} invalid={!!error} innerRef={inputEl} />
      <Label for='content' className="faqLabel">{t("Answer:")}</Label>
      <Input type='textarea' className="faqContentEdit" name='content' placeholder={t("Enter the faq content")} value={content} onChange={e => setContent(e.target.value)} invalid={!!error} innerRef={inputEl} />

      <FormFeedback>{error}</FormFeedback>
    </FormGroup>;
}